module.exports = __webpack_public_path__ + "static/media/ndsc_cover.df39709d.png";